var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-shrink-0 tw-bg-gray-200",class:{
    'tw-h-px tw-w-full': _vm.orientation === 'horizontal',
    'tw-w-px': _vm.orientation === 'vertical',
  }},[_vm._v(" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }